/**
 * Capability Registry — enum de classes polimórficas (ADR-082).
 *
 * Nomes alinhados ao OpenAPI v1 (`CapabilityRegistryEntry.class`) e ao
 * Prisma enum `RegistryClass`. Note a transformação kebab-case ↔ snake_case:
 * Engine/REST usam kebab-case (`feature-flag`); Prisma usa snake_case
 * (`feature_flag`). Conversores ficam neste módulo para fonte única.
 *
 * A classe `capability` é nominalmente equivalente ao "feature" da ADR-082
 * narrativa — a convenção do OpenAPI prevaleceu durante a Sessão 4 da
 * Auditoria e foi materializada nos schemas Capability.yaml e
 * CapabilityRegistryEntry.yaml.
 */
export const REGISTRY_CLASSES = [
    'capability',
    'feature-flag',
    'bond-permission-compatibility',
    'bond-type-requirements',
    'bond-role-compatibility',
    'subject-type-compatibility',
    'identity-merge-policy',
    'mcp-tool-risk-class',
    'outbound-policy-rule',
];
const PRISMA_CLASS_BY_REGISTRY = {
    capability: 'capability',
    'feature-flag': 'feature_flag',
    'bond-permission-compatibility': 'bond_permission_compatibility',
    'bond-type-requirements': 'bond_type_requirements',
    'bond-role-compatibility': 'bond_role_compatibility',
    'subject-type-compatibility': 'subject_type_compatibility',
    'identity-merge-policy': 'identity_merge_policy',
    'mcp-tool-risk-class': 'mcp_tool_risk_class',
    'outbound-policy-rule': 'outbound_policy_rule',
};
const REGISTRY_CLASS_BY_PRISMA = Object.fromEntries(Object.entries(PRISMA_CLASS_BY_REGISTRY).map(([k, v]) => [v, k]));
export function toPrismaClass(klass) {
    return PRISMA_CLASS_BY_REGISTRY[klass];
}
export function fromPrismaClass(value) {
    const mapped = REGISTRY_CLASS_BY_PRISMA[value];
    if (!mapped) {
        throw new Error(`Valor inválido de RegistryClass Prisma: ${value}`);
    }
    return mapped;
}
export function isRegistryClass(value) {
    return REGISTRY_CLASSES.includes(value);
}
//# sourceMappingURL=classes.js.map